import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getIllustrationMappingsData,
  createIllustrationMapping,
  updateIllustrationMapping,
  deleteIllustrationMapping,
  getIllustrationMappingInfo,
} from "../api/illustration-mappings"
import { formatISODate } from "../utils/datetime"

export const useIllustrationMappingsData = ({ page, limit, sortBy, filters }) =>
  useQuery({
    queryKey: ["illustration-mappings", page, limit, sortBy, filters],
    queryFn: () =>
      getIllustrationMappingsData({ page, limit, sortBy, filters }),
    select: (data) => ({
      ...data,
      data: data?.data?.map(toHerniationMapping) || [],
    }),
    retry: false,
  })

const toHerniationMapping = (mappingDto) => ({
  ...mappingDto,
  createdBy: mappingDto?.Creator?.username || "N/A",
  lastModifiedBy: mappingDto?.Updater?.username || "N/A",
  createdAt: formatISODate(mappingDto?.CreatedAt) || "",
})

export const useCreateIllustrationMappings = ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const queryClient = useQueryClient()
  const queryKey = ["illustration-mappings", page, limit, sortBy, filters]
  return useMutation({
    mutationFn: createIllustrationMapping,
    onError: (err) => console.error(err),
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  })
}

export const useUpdateIllustrationMappings = ({
  illustrationMappingId,
  page,
  limit,
  sortBy,
  filters,
}) => {
  const queryClient = useQueryClient()
  const queryKey = ["illustration-mappings", page, limit, sortBy, filters]
  const singleRestrictedillustrationMappingKey = [
    "illustration-mappings",
    illustrationMappingId,
  ]
  return useMutation({
    mutationFn: updateIllustrationMapping,
    onError: (err) => console.error(err),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey })
      queryClient.invalidateQueries({ singleRestrictedillustrationMappingKey })
    },
  })
}

export const useDeleteIllustrationMappings = ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const queryClient = useQueryClient()
  const queryKey = ["illustration-mappings", page, limit, sortBy, filters]
  return useMutation({
    mutationFn: deleteIllustrationMapping,
    onError: (err) => console.error(err),
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  })
}

export const useIllustrationMappingInfo = (mappingId) =>
  useQuery({
    queryKey: ["whitelisted-issuer", mappingId],
    queryFn: () => getIllustrationMappingInfo(mappingId),
    enabled: !!mappingId,
  })
